/*
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */

import axios from "axios"
import router from "../router"
import store from "../store"

// 请求环境
const baseURL = process.env.NODE_ENV === "development" ? "http://192.168.2.4:8601/" : "https://lzsg.ganmiaoedu.com:9072/"
axios.defaults.baseURL = baseURL
axios.defaults.timeout = 30000
axios.defaults.headers["Content-Type"] = "application/json"

// 请求拦截
axios.interceptors.request.use(
  config => {
    const token = store.state.token
    token && (config.headers.token = token)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
axios.interceptors.response.use(
  response => {
    const { status, data } = response
    const { url } = response.config
    if (status === 200) {
      if (url.includes("download")) {
        return Promise.resolve(response)
      }
      if (data.code === 100) {
        return Promise.resolve(data)
      } else {
        if (data.code === 999) {
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath },
          })
          return Promise.reject({ desc: "登录已过期，请重新登录" })
        }
        return Promise.reject(data)
      }
    } else {
      return Promise.reject(data)
    }
  },
  error => {
    const { response } = error
    if (!response) {
      return Promise.reject({ desc: "网络连接超时，请重试" })
    } else {
      switch (response.status) {
        case 404:
          return Promise.reject({ desc: "请求的资源未找到" })
        default:
          return Promise.reject({ desc: response.data.desc })
      }
    }
  }
)

export default axios
